<template>
  <div>
    <div
      class="selectBox"
      style="position: fixed; z-index: 10; top: 0.5rem; margin-left: 0.1rem"
    >
      <div id="pickers" ref="pickers" @click="fastSel">{{ value }}</div>
      <div style="display: flex; max-height: 2.2rem">
        <div
          class="typePic"
          @click.prevent.stop="closeChild"
          style="
            background-color: #fff;
            box-shadow: 0px 0px 0.06rem 0px rgba(0, 0, 0, 0.07);
            font-size: 0.23rem;
          "
          v-show="chooseFlag"
        >
          <div @click.prevent.stop="allClear">全省线路</div>
          <div @click.prevent.stop="roadSel">按线路查看</div>
          <div @click.prevent.stop="citySel">按城市查看</div>
        </div>
        <div class="itemPic roadPic" v-show="roadFlag">
          <ul>
            <li v-for="(item, index) in roadLists" :key="index" @click="lightRoad(item)">
              {{ item.shortname }}
            </li>
          </ul>
        </div>
        <div class="itemPic cityPic" v-show="cityFlag">
          <ul>
            <li v-for="(item, index) in cityLists" :key="index" @click="lightCity(item)">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="bgClose"
      @click.prevent.stop="closeChild"
      v-show="roadFlag || cityFlag"
    ></div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      value: "快速选择",
      chooseFlag: false,
      roadFlag: false,
      roadLists: [],
      cityFlag: false,
      cityLists: [],
    };
  },
  mounted() {
    this.selectRoadList();
    this.selectCityList();
  },
  methods: {
    fastSel() {
      if (this.chooseFlag) return;
      this.chooseFlag = true;
      if (this.$route.params.browser.versions.weixin) {
        return;
      } else if (window.roadBaiduClick&&this.$route.params.browser.versions.ios) {
        window.roadBaiduClick('10');
      } else if (window.liaoningactivity&&window.liaoningactivity.roadBaiduClick&&this.$route.params.browser.versions.android) {
        window.liaoningactivity.roadBaiduClick('10');
      }
    },
    allClear() {
      this.$emit("allClear", 1);
      this.value = "快速选择";
      this.$refs.pickers.classList = "";
      this.chooseFlag = false;
      this.roadFlag = false;
      this.cityFlag = false;
    },
    roadSel() {
      this.roadFlag = true;
      this.cityFlag = false;
    },
    citySel() {
      this.roadFlag = false;
      this.cityFlag = true;
    },
    closeChild() {
      console.log(12345);
      this.roadFlag = false;
      this.cityFlag = false;
    },
    lightRoad(obj) {
      console.log("objobjobjobjobj");
      console.log(obj);
      this.$emit("lightRoad", obj);
      this.value = obj.shortname;
      this.$refs.pickers.classList = "active";
      this.chooseFlag = false;
      this.roadFlag = false;
      this.cityFlag = false;
    },
    // 查询路线
    selectRoadList() {
      this.$Post(
        "highwayInfoSVGWeb/fetchRoadline",
        {},
        ({ data }) => {
          console.log(data);
          this.roadLists = data;
          if (this.$route.query.roadoldid) {
            let obj = this.roadLists.find((item) => {
              return item.roadoldid == this.$route.query.roadoldid;
            });
            setTimeout(() => {
              this.lightRoad(obj);
            }, 10);
          }
        },
        (err) => {
          this.$alertShow(err.msg);
        },
        true
      );
    },
    // 城市高亮
    lightCity(obj) {
      this.$emit("lightCity", obj);
      this.value = obj.name;
      this.$refs.pickers.classList = "active";
      this.chooseFlag = false;
      this.roadFlag = false;
      this.cityFlag = false;
    },
    // 查询城市
    selectCityList() {
      this.$Post(
        "highwayInfoSVGWeb/fetchPathByCity",
        {},
        ({ data }) => {
          console.log("citydata");
          console.log(data);
          this.cityLists = data;
          if (this.$route.query.cityName) {
            let obj = this.cityLists.find((item) => {
              return item.name == this.$route.query.cityName;
            });
            setTimeout(() => {
              this.lightCity(obj);
            }, 10);
          }
        },
        (err) => {
          this.$alertShow(err.msg);
        },
        true
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
#pickers {
  padding: 0.12rem 0.16rem;
  font-size: 0.13rem;
  border-radius: 1rem;
  box-shadow: 0px 0px 0.04rem 0px #eaeaea;
  text-align: center;
  background: #fff;
  color: #199ef4;
}
#pickers.active {
  background-color: #fea32c;
  color: #fff;
}
.selectBox {
  .typePic div {
    font-size: 0.13rem;
    padding: 0.1rem;
  }
  .typePic div:hover {
    color: #199ef4;
  }
  .itemPic {
    overflow-y: auto;
    background-color: #f6f6f6;
    li {
      padding: 0.1rem;
      font-size: 0.13rem;
    }
  }
}
.bgClose {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/selectBox.vue